export function getLanguage() {
    return localStorage.getItem('language');
  }
  
  export function setLanguage(lang) {
    localStorage.setItem('language', lang);
  }
  